import ActionRegister from '@/docs-partials/api/endpoints/action-register.mdx';
import * as React from 'react';
export default {
  ActionRegister,
  React
};